import React from 'react';
import Avatar from '@mui/material/Avatar';
import { getStudentAvatar } from './studentAvatar';

export default function StudentAvatarView({ studentId, avatarId, starterEmoji, name = 'Öğrenci', size = 48, sx }) {
  const avatar = getStudentAvatar(studentId, avatarId, starterEmoji);
  return <Avatar role="img" aria-label={`${name} avatarı`} alt="" src={avatar.imageUrl || undefined}
    imgProps={{ loading: 'lazy', decoding: 'async' }}
    sx={{ width: size, height: size, flexShrink: 0, bgcolor: avatar.bgColor, border: '1px solid', borderColor: avatar.borderColor,
      fontSize: typeof size === 'number' ? size * 0.52 : 28, '& img': { objectFit: 'contain', p: '3px' }, ...sx }}>
    {avatar.avatar}
  </Avatar>;
}
